exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label{\n  background-color: whitesmoke;\n  font-size: larger;\n}\n\n\n.roundButton{\n  height: 150px;\n  width: 150px;\n  border-radius: 50%;\n  border: 1px solid red;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/drink-automatic-machine/drink-automatic-machine.component.css
// module id = ../../../../../src/app/drink-automatic-machine/drink-automatic-machine.component.css
// module chunks = main